module.exports = __webpack_public_path__ + "static/media/checklist-v2.36d8be42.svg";